import React from 'react';
import './index.less';
import StockCard from './StockCard';

interface propsType {
	data: any;
}
export default (props: propsType) => {
	const stockInfo = props.data;

	return (
		<div className='stock-list' style={{ backgroundColor: 'white' }}>
			<StockCard data={stockInfo} />
		</div>
	);
};
